export default angular
    .module('westBerkshireEvents.ngClickCopy')
    .directive('ngClickCopy', ['$window', '$location', 'AlertService', function ($window, $location, AlertService) {

        var textarea;

        function isOS() {
            return navigator.userAgent.match(/ipad|iphone/i);
        }

        function createTextArea(text) {
            textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
        }

        function selectText() {
            var range,
                selection;
            if (isOS()) {
                range = document.createRange();
                range.selectNodeContents(textarea);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                textarea.setSelectionRange(0, 999999);
            } else {
                textarea.select();
            }
        }

        function copyToClipboard() {
            document.execCommand('copy');
            try {
                var successful = document.execCommand('copy');
                if (!successful) {
                    throw successful;
                } else {
                    AlertService.success({ msg: 'The link to this event has been copied' });
                }
            } catch (err) {
                AlertService.danger({ title: alert.title, msg: alert.msg, persist: alert.persist });
            }
            textarea.remove();
        }

        function copy (text) {
            createTextArea(text);
            selectText();
            copyToClipboard();
        }

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('click', function (e) {
                    // get the id of the event and add it as a parameter to the URL
                    var id = "?event_id=" + scope.event.id;
                    // passing through the company id of the event into the request parameters otherwise 
                    // we get a 403 because the wrong company id is used for all events journey
                    var companyId = "&companyId=" + scope.event.company_id;
                    var url = $location.absUrl().split('?')[0] + id + companyId;
                    copy(url);
                });
            }
        };
    }]);


// WEBPACK FOOTER //
// src/public/javascripts/copy-permalink/copy_permalink.directive.js